import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Upload, message, Progress } from 'antd'
import React from 'react'
import {baseUrl} from '../../../services/api/base-url'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'
import { getAuthHeaders } from '../../../services/lib/utils/auth.utils'

export const imgStringToArray = (str:any) => {
  if (!str || !str.includes('url')) {
    return []
  }

  return str.split('---').map((row:any) => JSON.parse(row))
}

export const imgArrayToString = (arr:any) => {
  return arr.map((row:any) => JSON.stringify(row)).join('---')
}

interface CommonEditImageComponentPropsInterface {
  formItems: any,
  propsFn: any
}

const CommonEditImageComponent:React.FC<CommonEditImageComponentPropsInterface> = (props:any) => {
  // 文件大小限制：25MB
  const MAX_FILE_SIZE = 25 * 1024 * 1024 // 25MB in bytes

  const beforeUpload = (file: any) => {
    console.log('🔍 上传文件检查:', file.name, file.size, '最大限制:', MAX_FILE_SIZE)

    // 检查文件大小
    if (file.size > MAX_FILE_SIZE) {
      const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2)
      const errorMsg = `文件大小超出限制！最大允许 25MB，当前文件大小为 ${fileSizeMB}MB`

      console.error('🔍', errorMsg)

      // 使用多种方式提示用户
      SweetAlertService.errorMessage(errorMsg)
      return false // 阻止上传
    }

    console.log('🔍 文件大小符合要求，允许上传')
    return true // 允许上传
  }

  const onUploadChange = (propsUpload:any) => {
    const imgUrls:any = []
    if (propsUpload.file.response) {
      propsUpload.fileList.map((row:any, index:any) => {
        imgUrls.push({
          uid: ++index,
          name: row.name,
          url: row.url || row.response
        })
      })
      if (imgUrls && imgUrls.length) {
        const imgUrlsStringed = imgArrayToString(imgUrls)
        props.propsFn.onChange(imgUrlsStringed)
      }
    }
  }

  // 自定义上传项渲染 - 只显示图片缩略图和删除按钮，不显示文件名
  const itemRender = (originNode: any, file: any, fileList: any, actions: any) => {
    // 获取截断后的文件名
    const truncatedName = (file.name || '')?.length > 10
      ? (file.name || '')?.substring(0, 10) + '...'
      : (file.name || '')

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
        {/* 图片缩略图 */}
        <img
          src={file.url || file.response || file.thumbUrl}
          alt={file.name}
          style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4, border: '1px solid #d9d9d9' }}
        />
        {/* 只在上传过程中显示自定义进度指示器，显示截断的文件名 */}
        {file.status === 'uploading' && (
          <div style={{ flex: 1, maxWidth: '200px' }}>
            <div style={{ fontSize: '12px', marginBottom: '4px', color: '#666' }}>
              {truncatedName}
            </div>
            <Progress
              percent={file.percent || 0}
              size="small"
              status="active"
            />
          </div>
        )}
        {file.status !== 'uploading'  && (
          <DeleteOutlined
            onClick={actions.remove}
            style={{
              color: 'red',
              marginLeft: 8,
              fontSize: '16px',
              cursor: 'pointer'
            }}
          />
        )}
      </div>
    )
  }

  return (
    <>
      <Upload
        action= {baseUrl + 'Common/UploadImage'}
        headers={getAuthHeaders()}
        name="imageFile"
        multiple
        listType="picture"
        defaultFileList={[...imgStringToArray(props.formItems.value)]}
        onChange={onUploadChange}
        beforeUpload={beforeUpload}
        itemRender={itemRender}
        onRemove={(file:any) => {
          if (!file.response && file.url) {
            const imgUrls = imgStringToArray(props.formItems.value)
            const resultImgUrls = imgUrls.filter((row:any) => row.url !== file.url)
            props.propsFn.onChange(imgArrayToString(resultImgUrls))
          }
        }}
      >
        <Button icon={<UploadOutlined />}>Upload</Button>
      </Upload>
    </>
  )
}

export default CommonEditImageComponent
